import { combineReducers } from 'redux';
import basic from './basic';
import salary from '../../pages/site/salaryScheme/store';

// 集合reducer函数
const rootReducer = combineReducers({
  basic,
  salary,
});

export default rootReducer;
